import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckAlt = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 6,
	viewBox: "0 0 8 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.35283 0.938494C7.66525 1.25091 7.66525 1.75744 7.35283 2.06986L4.06999 5.35271C3.75757 5.66513 3.25104 5.66513 2.93862 5.35271L0.655773 3.06986C0.343354 2.75745 0.343354 2.25091 0.655773 1.93849L0.938616 1.65565C1.25104 1.34323 1.75757 1.34323 2.06999 1.65565L3.36288 2.94854C3.44098 3.02665 3.56762 3.02665 3.64572 2.94854L5.93862 0.655651C6.25104 0.343232 6.75757 0.343232 7.06999 0.655651L7.35283 0.938494Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCheckAlt);
export { ForwardRef as ReactComponent };
